import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=d436187e"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d436187e')) {
      api.createRecord('d436187e', component.options)
    } else {
      api.reload('d436187e', component.options)
    }
    module.hot.accept("./Dropdown.vue?vue&type=template&id=d436187e", function () {
      api.rerender('d436187e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dropdown.vue"
export default component.exports